import React from "react";
import './css/DiscoverStyle.css';
import { Link } from "react-router-dom";
import vigyanvrikshyoutube1 from './images/vigyan-vriksh-himanshu-papnai-air1-iitgate-2024.jpg'
import vigyanvrikshyoutube2 from './images/vigyan-90marks-physical-chemistrytopics.jpg';
import vigyanvrikshyoutube3 from './images/vigyan-vriksh-csirnet-tepeatertrap.jpg';


function Discover() {
    return (
        <section class="py-5 discoverbox">
            <div class="container-fluid p-5 text-center">
                <h2 class="fw-bold">Discover, Learn, <span class="text-danger">And</span> <span class="text-primary">Grow</span></h2>
                <p class="text-muted mb-5 mx-auto text-center headingp">Discover new knowledge, learn with experts, and grow towards your academic and career goals.</p>
                <div class="row gy-4">
                    <div class="col-md-4">
                        <div class="card h-100 border-0">
                            <div class="image-wrapper">
                                <img src={vigyanvrikshyoutube1} class="card-img-top rounded-3" alt="Himanshu Papnai's Journey: Navodaya school To IIT Bombay, Culture, Challenges | AIR 1 IIT GATE 2024" />
                            </div>
                            <div class="card-body text-start">
                                <h5 class="card-title fw-bold mt-2">Himanshu Papnai's Journey: Navodaya school To IIT Bombay, Culture, Challenges | AIR 1 IIT GATE 2024</h5>
                                <p class="card-text">Odio faucibus ante ante nibh imperdiet ornare Aliquam suscipit, erat vel pharetra tempus, enim sem...</p>
                                <Link to="https://www.youtube.com/watch?v=XAWBVs5Yi-c" target="_blank" class="btn btn-danger readmorebut" title="Himanshu Papnai's Journey: Navodaya school To IIT Bombay, Culture, Challenges | AIR 1 IIT GATE 2024">Read More</Link>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card h-100 border-0">
                            <div class="image-wrapper">
                                <img src={vigyanvrikshyoutube2} class="card-img-top rounded-3" alt="90 Marks in Physical Chemistry? It's Easier with These Frequently Asked Topics!" />
                            </div>
                            <div class="card-body text-start">
                                <h5 class="card-title fw-bold mt-2">90 Marks in Physical Chemistry? It's Easier with These Frequently Asked Topics!</h5>
                                <p class="card-text">Odio faucibus ante ante nibh imperdiet ornare Aliquam suscipit, erat vel pharetra tempus, enim sem...</p>
                                <Link to="https://www.youtube.com/watch?v=zD1_-TRFEDo" target="_blank" class="btn btn-danger readmorebut" title="90 Marks in Physical Chemistry? It's Easier with These Frequently Asked Topics!">Read More</Link>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card h-100 border-0">
                            <div class="image-wrapper">
                                <img src={vigyanvrikshyoutube3} class="card-img-top rounded-3" alt="They Try Again… And FAIL! The 99% CSIR NET Repeater Trap #csirnet #chemicalsciences" />
                            </div>
                            <div class="card-body text-start">
                                <h5 class="card-title fw-bold mt-2">They Try Again… And FAIL! The 99% CSIR NET Repeater Trap #csirnet #chemicalsciences</h5>
                                <p class="card-text">Odio faucibus ante ante nibh imperdiet ornare Aliquam suscipit, erat vel pharetra tempus, enim sem...</p>
                                <Link to="https://www.youtube.com/watch?v=3KWYFe9LMzA" target="_blank" title="They Try Again… And FAIL! The 99% CSIR NET Repeater Trap #csirnet #chemicalsciences" class="btn btn-danger readmorebut">Read More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default Discover;